var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCo2Electricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75002 1.5L3.07011 9.51589C2.8085 9.82982 2.6777 9.98678 2.6757 10.1193C2.67396 10.2346 2.72532 10.3442 2.81496 10.4167C2.91808 10.5 3.1224 10.5 3.53104 10.5H9.00002L8.25002 16.5L14.9299 8.48411C15.1915 8.17018 15.3223 8.01322 15.3243 7.88065C15.3261 7.76541 15.2747 7.65577 15.1851 7.58333C15.082 7.5 14.8776 7.5 14.469 7.5H9.00002L9.75002 1.5Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2Electricity);
export default __webpack_public_path__ + "static/media/co2-electricity.a261fca0b0a3e972a66733389c498314.svg";
export { ForwardRef as ReactComponent };